import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../../ui/button';
import { Warning, X } from '@phosphor-icons/react';

export const WarningModal = ({ warnings, onClose, onProceed }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-white rounded-2xl p-6 max-w-lg w-full shadow-2xl"
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-[#FEF3C7] flex items-center justify-center">
              <Warning className="w-6 h-6 text-[#F59E0B]" weight="duotone" />
            </div>
            <h3 className="text-lg font-bold text-[#0F172A]">Value Verification Required</h3>
          </div>
          <button onClick={onClose} className="text-[#94A3B8] hover:text-[#64748B]">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="space-y-2 mb-6">
          {warnings.map((warning, index) => (
            <div key={index} className="bg-[#FEF3C7] rounded-lg p-3">
              <p className="text-sm text-[#92400E]">{warning}</p>
            </div>
          ))}
        </div>
        <div className="flex gap-3">
          <Link to="/data-entry" className="flex-1">
            <Button variant="outline" className="w-full border-2 border-[#5B21B6] text-[#5B21B6] rounded-xl h-11">
              Edit Values
            </Button>
          </Link>
          <Button onClick={onProceed} className="flex-1 bg-[#5B21B6] hover:bg-[#4C1D95] rounded-xl h-11">
            Continue Anyway
          </Button>
        </div>
      </motion.div>
    </div>
  );
};
